import {
  Disclaimer,
  Div,
  lightTheme,
  Pill,
  TooltipIcon,
} from '@vgrubs/components';
import { vDriveDeliveryStatus } from 'components/src/types/api/wallet.types';
import { RenderStatus } from '../DeliveriesStyled';

export const DeliveryStatusPill = ({
  status,
  cancellationReason,
}: {
  status: vDriveDeliveryStatus;
  cancellationReason?: string | null;
}) => {
  const renderStatusName = (text: string) => {
    if (!text) return ''; // Handle empty input
    return text.replace(/_/g, ' '); // Replace all underscores with spaces
  };

  return (
    <Pill $background={RenderStatus(status)?.color}>
      <Div $flex $alignCenter $gap="4px">
        <Disclaimer
          $m="0"
          $color={lightTheme.white}
          $capitalize
          $semiBold
          $lineHeight={'1'}
        >
          {renderStatusName(status)}
        </Disclaimer>

        {cancellationReason && (
          <TooltipIcon
            tooltip={cancellationReason}
            color={lightTheme.white}
          />
        )}
      </Div>
    </Pill>
  );
};
